import React, { forwardRef } from 'react'
import clsx from 'clsx'

/**
 *
 * @param children
 * @param asComponent
 * @param className
 * @param bgClassName
 * @param spacingClassName
 * @param rest
 */
const Button = forwardRef(function Button(
  { children, asComponent, className, bgClassName, spacingClassName, textClassName, roundedClassName, ...rest },
  ref
) {
  const Element = asComponent || 'button'
  return (
    <Element
      ref={ref}
      className={clsx(
        'font-semibold',
        textClassName || 'text-white',
        roundedClassName || 'rounded-md',
        spacingClassName || 'px-5 py-3',
        bgClassName || 'bg-orange-500 hover:bg-orange-400 active:bg-orange-600',
        className
      )}
      {...rest}
    >
      {children}
    </Element>
  )
})

export default Button
